import { io } from "socket.io-client";
let socket = null;

if (process.env.REACT_APP_IS_SOCKET === "true") {
    socket = io.connect(process.env.REACT_APP_SOCKET_SERVER, {
        transports: ["websocket"],
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 500,
        reconnectionDelayMax: 3000,
        timeout: 10000,
        forceNew: false,
    });
}

const oversMap = {
  "overId": "oid",
  "commentaryId": "cid",
  "teamId": "tid",
  "over": "ov",
  "bowlerId": "bid",
  "ballCount": "bc",
  "totalRun": "tr",
  "totalFour": "t4",
  "totalSix": "t6",
  "totalWideBall": "twb",
  "totalWideRun": "twr",
  "totalNoball": "tnb",
  "totalNoBallRun": "tnr",
  "totalByesRun": "tby",
  "totalLegByesRun": "tlb",
  "totalPanelty": "tpl",
  "totalWicket": "twk",
  "dotBall": "db",
  "isComplete": "cmp",
  "isOverInPowerplay": "opp",
  "powerplayType": "ppt",
  "isMaiden": "mdn",
  "date": "dt",
  "currentInnings": "inn",
  "teamScore": "sc",
  "isPowerPlay": "ipp",
  "overType": "oty",
  "overTypeName": "otn",
  "powerPlayName": "ppn",
  "type": "type"
};

const ballByBallsMap = {
  "commentaryBallByBallId": "cbb",
  "commentaryId": "cid",
  "teamId": "tid",
  "overId": "oid",
  "overCount": "ovc",
  "currentOverBalls": "cob",
  "bowlerId": "bid",
  "batStrikeId": "sid",
  "batNonStrikeId": "nsid",
  "ballIsCount": "bic",
  "ballType": "bt",
  "ballIsDot": "dot",
  "ballRun": "run",
  "ballExtraRun": "ex",
  "ballIsBoundry": "bnd",
  "ballFour": "f4",
  "ballSix": "s6",
  "ballIsWicket": "wkt",
  "ballWicketType": "wty",
  "ballPlayerId": "pid",
  "ballBowlerId": "bbid",
  "ballFielderId1": "f1",
  "ballFielderId2": "f2",
  "overIsMaiden": "mdn",
  "nextBatStrikeId": "ns",
  "nextBatNonStrikeId": "nns",
  "isDelete": "del",
  "currentInnings": "inn",
  "autoStrikeBallCount": "asb",
  "commentaryPartnershipId": "cpid",
  "teamScore": "sc",
  "teamWicket": "wk",
  "cardKey": "ck",
  "cardType": "ct",
  "tpId": "tpid",
  "createdDate": "cdt",
  "commentary": "com",
  "type": "type"
};

const partnershipMap = {
  "commentaryPartnershipId": "cpid",
  "commentaryId": "cid",
  "teamId": "tid",
  "batter1Id": "b1id",
  "batter2Id": "b2id",
  "batter1Name": "b1",
  "batter2Name": "b2",
  "totalRuns": "tr",
  "totalBalls": "tb",
  "extras": "ex",
  "commentaryBallByBallId": "cbb",
  "currentInnings": "inn",
  "batter1Balls": "b1b",
  "batter2Balls": "b2b",
  "batter1Runs": "b1r",
  "batter2Runs": "b2r",
  "totalFour": "t4",
  "totalSix": "t6",
  "totalExtra": "tex",
  "totalWide": "twd",
  "totalNoBall": "tnb",
  "order": "ord",
  "isActive": "iac",
  "p1Ball": "p1b",
  "p2Ball": "p2b",
  "p1Run": "p1r",
  "p2Run": "p2r",
  "teamScore": "sc",
  "teamWicket": "wk",
  "type": "type",
  "player1image": "p1i",
  "player1jerseyandimage": "p1ji",
  "player1jerseyandimagepath": "p1jp",
  "player2image": "p2i",
  "player2jerseyandimage": "p2ji",
  "player2jerseyandimagepath": "p2jp",
  "createdDate": "cdt"
};

const shortKeys = {
  "commentaryDetails": {
    "commentaryId": "cid",
    "matchTypeId": "mtid",
    "matchType": "mt",
    "eventTypeId": "etid",
    "team1Id": "t1id",
    "team2Id": "t2id",
    "team1Name": "te1n",
    "team2Name": "te2n",
    "competitionId": "cmpid",
    "competition": "cmp",
    "eventId": "eid",
    "eventDate": "edt",
    "eventName": "enm",
    "eventRefId": "erid",
    "location": "loc",
    "weather": "wth",
    "pitchCracks": "pcr",
    "tossWonBy": "twb",
    "choseTo": "cto",
    "winnerId": "wid",
    "winnerName": "wnm",
    "isClientShow": "ics",
    "displayStatus": "dst",
    "rmk": "rmk",
    "winRmk": "wrm",
    "cardType": "ct",
    "tossRmk": "trk",
    "commentaryStatus": "cst",
    "updateTime": "upt",
    "isMatchDraw": "imd",
    "target": "tgt",
    "marketId": "mid",
    "tpId": "tpid",
    "isSignalROn": "isr",
    "currentInnings": "inn",
    "systemPlayerCount": "spc",
    "isPlayersShow": "ips",
    "isPredictMarket": "ipm",
    "isActive": "iac",
    "isTeamPredictionOn": "itp",
    "createdBy": "cby",
    "lineRatio": "lr",
    "delay": "dly",
    "historyMatchTypeId": "hmt",
    "isCountInPoint": "icp",
    "shotType": "sht",
    "isWheelShow": "iws",
    "isTest": "tst",
    "eventNo": "eno",
    "isEventStart": "ies",
    "difficulty": "dif",
    "pitchHardness": "phd",
    "pitchWareSpeed": "pws",
    "pitchType": "pty",
    "lawnStriping": "lst",
    "pitchAge": "pag",
    "isVirtual": "ivt",
    "onfieldUmpires": "ofu",
    "thirdUmpire": "tum",
    "matchReferee": "mrf",
    "session": "ses",
    "countryId": "coid",
    "venueId": "vid",
    "scoringType": "sct",
    "pythonId": "pyi",
    "pythonURI": "pyu",
    "cancelTime": "ctm",
    "views": "vws",
    "streamingUrl": "stu",
    "streamingType": "sty",
    "shuffle": "shf",
    "statusNote": "snt",
    "developerName": "dev",
    "totalInnings": "tin",
    "commentaryCloseTime": "cct",
    "result": "res",
    "battingCondition": "btc",
    "pitchCondition": "ptc",
    "paceBowlingCondition": "pbc",
    "spineBowlingConniton": "sbc",
    "weatherCondition": "wcn",
    "temp": "tmp",
    "humidity": "hum",
    "visibility": "vis",
    "windSpeed": "wsp",
    "clouds": "cld",
    "competitionImage": "cim",
    "isPredict": "ipr"
  },
  "commentaryTeams": {
    "commentaryTeamId": "ctid",
    "commentaryId": "cid",
    "teamId": "tid",
    "shortName": "sn",
    "teamName": "tn",
    "teamCaptain": "tcp",
    "teamKipper": "tkp",
    "teamScore": "sc",
    "teamOver": "tov",
    "teamWicket": "wk",
    "crr": "crr",
    "rrr": "rrr",
    "teamStatus": "tst",
    "teamTrialRuns": "ttr",
    "teamLeadRuns": "tlr",
    "teamWideRuns": "twr",
    "teamByRuns": "tbr",
    "teamLegByRuns": "tlb",
    "teamNoBallRuns": "tnb",
    "teamPenaltyRuns": "tpr",
    "isWin": "iwn",
    "teamBattingOrder": "tbo",
    "currentInnings": "inn",
    "isBattingComplete": "ibc",
    "commentaryPlayerTeamCaptain": "cpc",
    "commentaryPlayerTeamKipper": "cpk",
    "teamColor": "tcl",
    "backgroundColor": "bgc",
    "teamMaxOver": "tmo",
    "isSuperOver": "iso",
    "teamPredictionPercentage": "tpp",
    "drsCount": "drs",
    "drsAttempt": "dra",
    "groupId": "gid",
    "drsFail": "drf",
    "subInning": "sin",
    "tpId": "tpid",
    "image": "img",
    "jersey": "jer",
    "nimage": "nimg",
    "njersey": "njer"
  },
  "commentaryPlayers": {
    "commentaryPlayerId": "cpid",
    "commentaryId": "cid",
    "teamId": "tid",
    "playerId": "pid",
    "playerName": "pn",
    "displayOrder": "dor",
    "batStatus": "bst",
    "batRun": "br",
    "batBall": "bb",
    "batDotBall": "bdb",
    "batFour": "b4",
    "batSix": "b6",
    "batSrr": "bsr",
    "battingOrder": "bor",
    "isPlay": "ipl",
    "onStrike": "osk",
    "wicketType": "wt",
    "bowlerId": "bid",
    "fielderId1": "f1",
    "fielderId2": "f2",
    "bowlerOver": "bov",
    "bowlerCurrentBall": "bcb",
    "bowlerTotalBall": "btb",
    "bowlerRun": "brn",
    "bowlerDotBall": "bdd",
    "bowlerMaidenOver": "bmo",
    "bowlerFour": "bf4",
    "bowlerSix": "bs6",
    "bowlerWideBall": "bwd",
    "bowlerNoBall": "bnb",
    "bowlerByeBall": "bby",
    "bowlerLegByeBall": "blb",
    "bowlerWideBallRun": "bwr",
    "bowlerNoBallRun": "bnr",
    "bowlerByeBallRun": "bbr",
    "bowlerLegByeBallRun": "blr",
    "bowlerTotalWicket": "bwk",
    "bowlerEconomy": "eco",
    "bowlerOnStrike": "bos",
    "bowlerPeneltyRun": "bpr",
    "isBatterOut": "ibo",
    "isBatterRetir": "ibr",
    "swapName": "swp",
    "batsmanAverage": "bav",
    "batsmanStrikeRate": "bsr2",
    "bowlerAverage": "bav2",
    "currentInnings": "inn",
    "batterOrder": "bato",
    "bowlerOrder": "bwor",
    "batsmanPreviousStrikeRate": "bpsr",
    "bowlerPreviousEconomy": "bpec",
    "isInPlayingEleven": "ipe",
    "boundary": "bnd",
    "bowlingType": "bty",
    "playerBallFaced": "pbf",
    "playerTypeId": "ptid",
    "displayName": "dn",
    "playerType": "pty",
    "jerseyPlayerImage": "jpi",
    "jerseyPlayerImagePath": "jpp",
    "tpId": "tpid",
    "isPlayInEvent": "pie",
    "createdDate": "cdt",
    "playerimage": "pimg",
    "isKipper": "ikp"
  },
  "commentaryBallByBall": ballByBallsMap,
  "commentaryWicket": {
    "commentaryWicketId": "cwid",
    "commentaryId": "cid",
    "bowlerId": "bid",
    "bowlerName": "bn",
    "wicketType": "wt",
    "batterId": "batid",
    "batterName": "bat",
    "fieldPlayerId": "fid",
    "fieldPlayerName": "fpn",
    "overId": "oid",
    "overCount": "ovc",
    "commentaryBallByBallId": "cbb",
    "teamId": "tid",
    "teamScore": "sc",
    "playerRun": "pr",
    "playerBalls": "pb",
    "wicketCount": "wc",
    "ballCount": "bc",
    "fieldPlayer2Id": "f2id",
    "fieldPlayer2Name": "f2n",
    "currentInnings": "inn",
    "type": "type",
    "isDelete": "del",
    "createdDate": "cdt"
  },
  "commentaryOvers": oversMap,
  "commentaryPartnership": partnershipMap,
  "entityOvers": oversMap,
  "entityBallByBalls": ballByBallsMap,
  "entityPartnerships": partnershipMap
};

const invertedShortKeys = {};
for (const module in shortKeys) {
  invertedShortKeys[module] = {};
  for (const [longKey, shortKey] of Object.entries(shortKeys[module])) {
    invertedShortKeys[module][shortKey] = longKey;
  }
}

const mapObject = (obj, module) => {
  if (!obj || typeof obj !== "object") return obj;
  const moduleMap = invertedShortKeys[module];
  if (!moduleMap) return obj;

  const newObj = { ...obj };
  for (const shortKey in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, shortKey)) {
      const longKey = moduleMap[shortKey];
      if (longKey !== undefined) {
        newObj[longKey] = obj[shortKey];
      }
    }
  }
  return newObj;
};

const mapShortScoreData = (data) => {
  if (!data || !Array.isArray(data.val)) return data;

  const mapDeleteModule = (item) => {
    if (!item || !item.data) return item;
    const data = { ...item.data };

    if (item.module === "deleteCommentaryBallByBallIds" || item.module === "deleteOverWicketParnerBallIds") {
      if (data.cbb !== undefined) data.commentaryBallByBallId = data.cbb;
    } else if (item.module === "deleteOverIds") {
      if (data.oid !== undefined) data.overId = data.oid;
    } else if (item.module === "deleteWicketIds") {
      if (data.cwid !== undefined) data.commentaryWicketId = data.cwid;
    } else if (item.module === "deletePartnershipIds") {
      if (data.cpid !== undefined) data.commentaryPartnershipId = data.cpid;
    }

    return { ...item, data };
  };

  const mappedValue = data.val.map((item) => {
    if (!item) return item;

    if (invertedShortKeys[item.module]) {
      let mappedData = item.data;
      if (Array.isArray(item.data)) {
        mappedData = item.data.map((obj) => mapObject(obj, item.module));
      } else if (item.data && typeof item.data === "object") {
        mappedData = mapObject(item.data, item.module);
      }
      return {
        ...item,
        data: mappedData,
      };
    } else if (
      item.module === "deleteCommentaryBallByBallIds" ||
      item.module === "deleteOverWicketParnerBallIds" ||
      item.module === "deleteOverIds" ||
      item.module === "deleteWicketIds" ||
      item.module === "deletePartnershipIds"
    ) {
      return mapDeleteModule(item);
    }

    return item;
  });

  return {
    ...data,
    commentaryId: data.cid !== undefined ? data.cid : data.commentaryId,
    eventId: data.eid !== undefined ? data.eid : data.eventId,
    val: mappedValue,
  };
};

const mapPlayersData = (data) => {
  if (!data || !Array.isArray(data.d)) return data;

  const mappedData = data.d.map((p) => mapObject(p, "commentaryPlayers"));
  return {
    ...data,
    commentaryId: data.cid !== undefined ? data.cid : data.commentaryId,
    d: mappedData,
  };
};

const mapGraphData = (data) => {
  if (!data || !Array.isArray(data.ov)) return data;

  const mappedOver = data.ov.map((o) => mapObject(o, "commentaryOvers"));
  return {
    ...data,
    ov: mappedOver,
  };
};

const mapEventData = (data) => {
  if (!data) return data;
  let mappedValue = data.val !== undefined ? data.val : data.value;
  if (mappedValue && typeof mappedValue === "object") {
    if (mappedValue.cm && typeof mappedValue.cm === "object") {
      mappedValue.cm = mapObject(mappedValue.cm, "commentaryDetails");
    }
  }
  return {
    ...data,
    commentaryId: data.cid !== undefined ? data.cid : data.commentaryId,
    value: mappedValue,
  };
};

const mapRunnerObject = (runner) => {
  if (!runner || typeof runner !== "object") return runner;
  const mappedRunner = { ...runner };
  if (runner.rnid !== undefined) mappedRunner.runnerId = runner.rnid;
  if (runner.rn !== undefined) mappedRunner.runner = runner.rn;
  if (runner.selid !== undefined) mappedRunner.selectionId = runner.selid;
  if (runner.bp !== undefined) mappedRunner.backPrice = runner.bp;
  if (runner.bs !== undefined) mappedRunner.backSize = runner.bs;
  if (runner.lp !== undefined) mappedRunner.layPrice = runner.lp;
  if (runner.ls !== undefined) mappedRunner.laySize = runner.ls;
  if (runner.tid !== undefined) mappedRunner.teamId = runner.tid;
  if (runner.tn !== undefined) mappedRunner.teamName = runner.tn;
  return mappedRunner;
};

const mapMarketObject = (market) => {
  if (!market || typeof market !== "object") return market;
  const mappedMarket = { ...market };
  if (market.emid !== undefined) mappedMarket.eventMarketId = market.emid;
  if (market.erid !== undefined) mappedMarket.eventRefId = market.erid;
  if (market.sts !== undefined) mappedMarket.status = market.sts;
  
  let runners = market.rns !== undefined ? market.rns : market.runners;
  if (Array.isArray(runners)) {
    mappedMarket.runners = runners.map(mapRunnerObject);
  }
  return mappedMarket;
};

const mapEventRunnerData = (data) => {
  if (!data) return data;
  let mappedValue = data.val !== undefined ? data.val : data.value;
  if (Array.isArray(mappedValue)) {
    mappedValue = mappedValue.map(mapMarketObject);
  }
  return {
    ...data,
    commentaryId: data.cid !== undefined ? data.cid : data.commentaryId,
    eventId: data.eid !== undefined ? data.eid : data.eventId,
    value: mappedValue,
  };
};

if (socket) {
    const originalOn = socket.on;
    const originalOff = socket.off;
    const callbackMap = new Map();

    socket.on = function (event, fn) {
        if (typeof fn === "function" && (event === "shortScoreData" || event === "playersData" || event === "graphData" || event === "eventData" || event === "eventRunnerData")) {
            const wrappedFn = (data) => {
                let mappedData = data;
                if (event === "shortScoreData") {
                    mappedData = mapShortScoreData(data);
                } else if (event === "playersData") {
                    mappedData = mapPlayersData(data);
                } else if (event === "graphData") {
                    mappedData = mapGraphData(data);
                } else if (event === "eventData") {
                    mappedData = mapEventData(data);
                } else if (event === "eventRunnerData") {
                    mappedData = mapEventRunnerData(data);
                }
                fn(mappedData);
            };
            if (!callbackMap.has(event)) {
                callbackMap.set(event, new Map());
            }
            callbackMap.get(event).set(fn, wrappedFn);
            originalOn.call(socket, event, wrappedFn);
        } else {
            originalOn.apply(socket, arguments);
        }
        return socket;
    };

    socket.off = function (event, fn) {
        if (event === "shortScoreData" || event === "playersData" || event === "graphData" || event === "eventData" || event === "eventRunnerData") {
            const eventMap = callbackMap.get(event);
            if (fn) {
                if (eventMap) {
                    const wrappedFn = eventMap.get(fn);
                    if (wrappedFn) {
                        originalOff.call(socket, event, wrappedFn);
                        eventMap.delete(fn);
                        return socket;
                    }
                }
                originalOff.call(socket, event, fn);
            } else {
                originalOff.call(socket, event);
                if (eventMap) {
                    eventMap.clear();
                }
            }
        } else {
            originalOff.apply(socket, arguments);
        }
        return socket;
    };
}

export default socket;